import { render, staticRenderFns } from "./slavedialog.vue?vue&type=template&id=61e749c4&scoped=true&"
import script from "./slavedialog.vue?vue&type=script&lang=js&"
export * from "./slavedialog.vue?vue&type=script&lang=js&"
import style0 from "./slavedialog.vue?vue&type=style&index=0&id=61e749c4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61e749c4",
  null
  
)

export default component.exports